import { css } from 'styled-components';

export const antdDrawer = css`
  .ant-drawer-right {
    transform: none !important;
  }
  .ant-drawer-close {
    display: none;
  }
  .ant-drawer-body {
    height: 100%;
  }
`;
